export default (path: string, routeQuery: string) => {
  const query = path.includes('?') && routeQuery
    ? `&${routeQuery.substr(1)}`
    : routeQuery;

  return `${process.env.PUBLIC_URL}${path}${query}`;
};
